__turbopack_context__.v({
  "banner": "aHvuKG_banner",
  "card": "aHvuKG_card",
  "image": "aHvuKG_image",
  "insideImage": "aHvuKG_insideImage",
  "outsideImage": "aHvuKG_outsideImage",
  "wrapper": "aHvuKG_wrapper",
});
